<template>
	<div id="ConfigGeneralComponent" class="config-general-component">
		<div>
			<div class="row">
				<div class="col-3">
					<div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
						<button class="nav-link active" id="v-pills-printers-tab" data-toggle="pill" data-target="#v-pills-printers" type="button" role="tab" aria-controls="v-pills-printers" aria-selected="true">Impresoras</button>
						<button class="nav-link" id="v-pills-profile-tab" data-toggle="pill" data-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" v-show="false">Profile</button>
					</div>
				</div>
				<div class="col-9">
					<div class="tab-content" id="v-pills-tabContent">
						<div class="tab-pane fade show active" id="v-pills-printers" role="tabpanel" aria-labelledby="v-pills-printers-tab">
							<p class="mb-2">Seleccione la impresora que corresponde para cada tipo de impresion</p>
							<div>
								<div class="form-group row">
									<label for="printerWebSocketServer" class="col-sm-3 col-form-label">Impresora de Etiqueta</label>
									<div class="col-sm-6">
										<select class="form-control form-control-sm" id="printerWebSocketServer" :disabled="!successFullConnectionWebSocketServer" v-model="indexSelectedPrinterWebSocketServer" @change="changeSelectedPrinterWebSocketServer">
											<option v-for="(item, index) in listPrinterWebSocketServer" :value="index" :key="index">{{ item }}</option>
										</select>
									</div>
									<div class="col-sm-2">
										<button class="btn btn-primary btn-sm" @click="toPrintWithVariables" :disabled="!successFullConnectionWebSocketServer">Imprimir</button>
									</div>
								</div>
								<div class="form-group row">
									<label for="printerFacturacionCLPrint" class="col-sm-3 col-form-label">Impresora de Boletas</label>
									<div class="col-sm-6">
										<select class="form-control form-control-sm" id="printerFacturacionCLPrint" :disabled="!successFullConnectionFacturacionCLPrint" v-model="indexSelectedPrinterFacturacionCLPrint" @change="changeSelectedPrinterFacturacionCLPrint">
											<option v-for="(item, index) in listPrinterFacturacionCLPrint" :value="index" :key="index">{{ item }}</option>
										</select>
									</div>
									<div class="col-sm-2">
										<button class="btn btn-primary btn-sm" @click="toPrintFacturacionCL(39, 1)" :disabled="!successFullConnectionFacturacionCLPrint">Imprimir</button>
									</div>
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">...</div>
						<div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">...</div>
						<div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">...</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
	import webSocketServer from '@/mixins/webSocketServer.js'
	import label from "@/mixins/labels/"

	export default {
		name: 'ConfigGeneralComponent',
		mixins: [axiosAction, errors, mixin, facturacionCLPrint, webSocketServer, label],
		props: [],
		data () {
			return {
			}
		},
		computed: {
		},
		methods: {
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.config-general-component {
	.nav {
		.nav-link {
			border-radius: 0;
			color: #adb5bd;
			text-align: left;
		}
		.active {
			border-left: 2px solid #007bff;
			background-color: transparent;
			color: #6c757d;
		}

	}
}
</style>
